import { render, staticRenderFns } from "./vpd-card-title.vue?vue&type=template&id=d565b2f6&scoped=true"
import script from "./vpd-card-title.vue?vue&type=script&lang=js"
export * from "./vpd-card-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d565b2f6",
  null
  
)

export default component.exports